import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { store } from "src/store";
import { ClientActionEnum } from "src/store/reducers/client/types";

const config: AxiosRequestConfig = {
  baseURL: `${process.env.REACT_APP_API}/client/`,
};
const instanceWithTokenNoAlert: AxiosInstance = axios.create(config);

instanceWithTokenNoAlert.interceptors.request.use((config) => {
  config.headers!.Authorization = `${localStorage.getItem("guest-token")}`;
  return config;
});

instanceWithTokenNoAlert.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("error", error);
    error.response.data === "Unauthorized"
      && store.dispatch({
        type: ClientActionEnum.EXIT,
        result: error.response.data,
      });
  }
);

export default instanceWithTokenNoAlert;
